import type { Departure } from '@jums-dashboard/shared';

export interface ReachabilitySplit {
  unreachable: Departure[];
  reachable: Departure[];
  firstReachableKey: string | null;
}

export function minutesUntil(d: Departure, now: number): number {
  return Math.floor((d.departureTimestamp - now) / 60_000);
}

export function isReachable(d: Departure, now: number, walkMinutes: number): boolean {
  return minutesUntil(d, now) >= walkMinutes;
}

function departureKey(d: Departure): string {
  return `${d.routeShortName}-${d.departureTimestamp}`;
}

export function splitByReachability(departures: Departure[], now: number, walkMinutes: number): ReachabilitySplit {
  const unreachable: Departure[] = [];
  const reachable: Departure[] = [];
  let firstReachableKey: string | null = null;

  for (const d of departures) {
    if (isReachable(d, now, walkMinutes)) {
      reachable.push(d);
      if (firstReachableKey === null) {
        firstReachableKey = departureKey(d);
      }
    } else {
      unreachable.push(d);
    }
  }

  return { unreachable, reachable, firstReachableKey };
}
